import isEnterpriseSubAccount, { enterpriseParentId } from './is-enterprise-sub-account'

// Sensor IDs that belong to the "selective" (fire-sprinkler) program.
// Any sensor ID starting with "EXFS" also qualifies. Mirrors the PHP rule.
export const SELECTIVE_SENSOR_IDS = new Set([
  "EX00MJ7Q47", "EX00GE6CK2", "EX009FH5HC", "EX00XRZE4L", "EX00BBL75F",
  "EX00G26FNY", "EX00PL5K4G", "EX002R52DR", "EX00ZR6M4D", "EX00LETYWQ",
  "EX005FXF6P", "EX00MLQ3KY", "EX007BTTKW", "EX00FJCZC4", "EX00JCJEAB",
  "EX0027N6N9", "EX00NGTYT4", "EX00E2ZZBR", "EX0069B2XW", "EX009LPF4L",
  "EX00RDGQYZ", "EX00RLGCDC", "EX00JTTE92", "EX00JJLM9Y", "EX00DADA3H",
  "EX00Z9T5HT", "EX00MH6WEQ", "EX00AEHY9W", "EX00XTQDQ3", "EX006DCDJA",
  "EX00T24QDP", "EX006KEL3J", "EX00JZMPFB", "EX00YZEXX9", "EX00D62J3C",
  "EX00JEPT9Y", "EX005PLYXG", "EX00ZQ693P", "EX00QAQTD3", "EX00A7FRHP",
  "EX007F6CB5", "EX00Q22KKJ", "EX00HYTN4N", "EX00QKJN74", "EX006D56WR"
]);

// Whether a given sensor ID is a selective (fire-sprinkler) sensor.
export default function isSelectiveSensor (sid) {
  if (!sid) return false;
  const trimmed = String(sid).trim();
  if (trimmed.indexOf('EXFS') === 0) return true;
  return SELECTIVE_SENSOR_IDS.has(trimmed);
}

// The enterprise accounts that run the selective program. A sub-account linked
// to one of these is in the program whichever sensor it happens to be setting
// up, which is the account-side version of the sensor-ID rule above.
export const SELECTIVE_ENTERPRISE_PARENT_IDS = [2, 4, 29];

// Whether this session belongs to the selective program. Only the parts of
// onboarding that are specific to fire sprinklers — the placement questionnaire —
// are gated on this; anything that applies to enterprise-managed sensors
// generally is gated on isEnterpriseSubAccount() instead.
export const isSelectiveEnterpriseAccount = (user = window.currentUser) => {
  return isEnterpriseSubAccount(user)
    && SELECTIVE_ENTERPRISE_PARENT_IDS.includes(enterpriseParentId(user));
};
